import React, { SyntheticEvent } from "react";
import { Button, FieldText, FieldSelect } from "@conserveit/blocks";
import { MsgAlert } from "..";
import { Hr, Container } from "./UserForm.styles";

interface Option {
  label: string;
  value: string | number;
}
type toggleDeactivateParams = [Insite.API.User, number, string, string, string];

interface Props {
  disabled: boolean;
  onChange: (
    e?: SyntheticEvent<HTMLInputElement, Event> | Option["value"],
    inputId?: string
  ) => void;
  rolesSelectOptions: Option[];
  groupOptions: Option[];
  user: Insite.API.User;
  handleToggleDeactivate: (
    ...toggleDeactivateParams: toggleDeactivateParams
  ) => void;
  formData: {
    [key: string]: any;
  };
  error: string;
}

const EditUserForm: React.FC<Props> = ({
  disabled,
  onChange,
  rolesSelectOptions,
  groupOptions,
  user,
  handleToggleDeactivate,
  formData,
  error,
}) => {
  const toggleDeactivateStyle = {
    destructive: true,
    additive: false,
  };
  let toggleDeactivateText = "Deactivate User";

  if (formData.status === "deleted") {
    toggleDeactivateStyle.additive = true;
    toggleDeactivateStyle.destructive = false;
    toggleDeactivateText = "Reactivate User";
  }

  const userRole: Option = {
    value: formData.user_role,
    label: formData.user_role,
  };

  const userGroupArray: Array<Option["value"]> = formData.user_group
    ? formData.user_group.split(",")
    : [];
  const userGroup = groupOptions.reduce<Option[]>((result, groupOption) => {
    if (userGroupArray.includes(groupOption.value)) {
      result.push(groupOption);
    }
    return result;
  }, []);

  const formatGroup = (selectedGroup: Option[]) =>
    selectedGroup.map(({ value }) => value).join(",");
  const formatRole = (selectedRole: Option) => selectedRole.value;

  const toggleDeactivateParams: toggleDeactivateParams = [
    user,
    formData.user_id,
    formData.user_username,
    formData.status,
    formData.user_email,
  ];

  return (
    <Container>
      <MsgAlert type="error" message={error} />
      <div className="UserEditForm">
        <Button
          thin
          onClick={() => handleToggleDeactivate(...toggleDeactivateParams)}
          {...toggleDeactivateStyle}
        >
          {toggleDeactivateText}
        </Button>

        <Hr />

        <FieldText
          name="user_email"
          type="email"
          label="Email"
          placeholder="Email"
          value={formData.user_email || ""}
          onChange={onChange}
          disabled={disabled || !formData.is_sub_user}
        />
        <FieldText
          name="user_fullname"
          type="text"
          label="Full Name"
          placeholder="Full Name"
          value={formData.user_fullname || ""}
          onChange={onChange}
          disabled={disabled}
        />

        <Hr />

        <FieldSelect
          className="t-SelectRole"
          label="Role"
          name="user_role"
          placeholder="Select..."
          value={userRole}
          onChange={(selectedItem) =>
            onChange(formatRole(selectedItem as Option), "user_role")
          }
          options={rolesSelectOptions}
          disabled={disabled}
          menuPosition="fixed"
        />

        <FieldSelect
          className="t-SelectGroup"
          label="Group"
          name="user_group"
          isMulti
          disabled={disabled}
          placeholder="Select..."
          options={groupOptions}
          value={userGroup}
          onChange={(selectedItems) =>
            onChange(formatGroup(selectedItems as Option[]), "user_group")
          }
          menuPosition="fixed"
        />
      </div>
    </Container>
  );
};

export default EditUserForm;
